import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { getOfferLetterData } from 'store/Recruitment/actions'
import AxiosInstance from 'utils/AxiosInstance'
import { generateOfferLetter } from 'utils/helpers'
import moment from 'moment'
import { sendOfferLetter } from 'store/Recruitment/actions'

function OfferLetterModal({
  showModal,
  setShowModal,
  applicationId,
  jobOnboard,
}) {
  const dispatch = useDispatch()
  const { offerLetterData } = useSelector((store) => store.recruitment)
  const [offerLetter, setOfferLetter] = useState('')

  const [salaryTypes, setSalaryTypes] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/offer_letter_settings`).then(
      (data) => {
        setOfferLetter(
          data && data.length && data[0].offer_letter_settings
            ? data[0].offer_letter_settings
            : ''
        )
      }
    )
  }, [])

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/salary_type`).then((data) => {
      setSalaryTypes(data)
    })
  }, [])

  const filledLetter = generateOfferLetter(offerLetter, {
    applicant_name: offerLetterData?.name ?? '',
    app_name: offerLetterData?.app_name ?? '',
    job_title: offerLetterData?.title ?? '',
    job_type: offerLetterData?.job_type ?? '',
    start_date: offerLetterData?.joining_date
      ? moment(offerLetterData?.joining_date).format('DD-MM-YYYY')
      : '',
    workplace_location: offerLetterData?.location ?? '',
    days_of_week: offerLetterData?.days_of_week ?? '',
    salary: offerLetterData?.salary ? `$${offerLetterData?.salary}` : '',
    salary_type: offerLetterData?.salary_type
      ? salaryTypes?.find(
          (letter) => letter?.id === offerLetterData?.salary_type
        )?.value
      : '',
    salary_duration: offerLetterData?.salary_duration ?? '',
    company_name: offerLetterData?.company_name ?? '',
  })

  useEffect(() => {
    dispatch(getOfferLetterData(applicationId))
  }, [dispatch, applicationId])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='xl'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        Offer Letter{' '}
        {offerLetterData?.offer_letter_sent ? (
          <span className='text-danger ml-3'>
            (Offer letter already emailed to this user!)
          </span>
        ) : null}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <div dangerouslySetInnerHTML={{ __html: filledLetter }}></div>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          customFn={() => {
            dispatch(
              sendOfferLetter({
                id: jobOnboard.id,
                email: offerLetterData.email,
                emailBody: filledLetter,
              })
            )
            setShowModal(false)
          }}
          text='Send Offer Letter'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default OfferLetterModal
